export const INCOMMODITY_SATISFACTION_MANAGER = {
  NAME: "매니저",
};
